import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";

function Pooldata() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);
  const [ClinetData, setClientData] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [clientEmail, setCleintEmail] = useState("");
  const [clientName, setClintName] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [claimStatus, setClaimStatus] = useState("")
  const [poolName, setPoolName] = useState("Silver");
  const [network_type, setNetworkType] = useState("");
  const [userStatus, setStatus] = useState("");
  const [stakeStatus, setStakeStatus] = useState("");
  const [viewData, setViewData] = useState("");
  const [page, setPage] = useState(1)


  const [editPaidAmount, setEditPaidAmount] = useState("");
  const [editFromAddress, setEditFromAddress] = useState("");
  const [editToAddress, setEditToAddress] = useState("");
  const [editTxnHash, setEditTxnHash] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [deposit_id, setDepositId] = useState([]);
  const [error, setError] = useState("");
  const [stakeData, setStakeData] = useState([]);



  useEffect(() => {

    fetchdataClient(1);
  }, []);


  const fetchdataClient = async (page) => {
    console.log('Token ', authToken);
    setPage(page)

    const searchData = {
      page: page,
      poolName: poolName,
      name: clientName,
      my_code: referralCode,
      status: userStatus,
      claim_status: claimStatus,
      user_role: 'user',
    };


    try {
      const client = await fetch(`${baseurl}/pool-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (client.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const clientData = await client.json();
      console.log('Static data', clientData.data.data);

      if (clientData.status) {
        setAnalytics(clientData.amalytics);
        setClientData(clientData.data.data);
        setPagination(clientData.pagination);
        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const passData = (dataClient) => {
    setStakeData(dataClient);
  };



  const updateDeposit = async () => {

    console.log(editPaidAmount, editFromAddress, editToAddress, editTxnHash, editStatus)

    if (!deposit_id) return setError("Try again.");
    if (!editPaidAmount) return setError("Paid amount id required.");
    if (!editFromAddress) return setError("From address is required");
    if (!editToAddress) return setError("To address is reuired.");
    if (!editTxnHash) return setError("Txn Hash is required.");
    if (!editStatus) return setError("Status is required.");
    if (!authToken) return setError("Authentication is required.");


    const formData = {
      deposit_id: deposit_id.id,
      paid_amount: editPaidAmount,
      from_address: editFromAddress,
      to_address: editToAddress,
      txn_hash: editTxnHash,
      status: editStatus
    };

    console.log("Sending Data:", formData);

    try {
      const response = await fetch(`${baseurl}/client/deposit-update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // Get raw response
      console.log("Raw API Response:", data); // Log response before parsing


      if (data.status) {
        toast.success(data.message)
        window.location.href = "";
      }
      else {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  }


  const handlePageChange = async (page) => {

    setTableLoading(false)
    fetchdataClient(page);
  }

  const searchData = () => {

    setTableLoading(false)
    fetchdataClient(1);
  }

  const handleProfileDataFetched = (data) => {

  }



  const excuteStake = async (stakeId) => {
    // alert(stakeId);


    const postData = {
      stake_id: stakeId,
    };


    try {
      const client = await fetch(`${baseurl}/excute-stake`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      });

      if (client.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const clientData = await client.json();

      if (clientData.status) {
        toast.success(client.message);

        fetchdataClient(page);
      }
      else {
        toast.error(client.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }

  }
  return (
    <>
      <Header>
        {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>


              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL Pool </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_pool : '0'}

                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">Active Pool </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.active_pool : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">Close Pool </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">

                            {analytics ? analytics.closed_pool : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">Close Pool </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">

                            ${analytics ? analytics.total_incom : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table ">
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 ">
                        <lavel>Name</lavel>
                        <input type="text" value={clientName} onChange={(e) => setClintName(e.target.value)} className="form-control" placeholder="Enter user Name" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3 ">
                        <lavel>Referral Code</lavel>
                        <input type="text" value={referralCode} onChange={(e) => setReferralCode(e.target.value)} className="form-control" placeholder="Enter Code" />
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Pool</label>
                        <select className="form-control" value={poolName} onChange={(e) => setPoolName(e.target.value)}>
                          <option value="Silver">Silver</option>
                          <option value="Gold">Gold</option>
                          <option value="Diamond">Diamond</option>
                          <option value="Platinum">Platinum</option>
                        </select>
                      </div>
                    </div>



                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Status</label>
                        <select className="form-control" value={userStatus} onChange={(e) => setStatus(e.target.value)}>
                          <option value="">All</option>
                          <option value="open">Active</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Claim Status</label>
                        <select className="form-control" value={claimStatus} onChange={(e) => setClaimStatus(e.target.value)}>
                          <option value="">All</option>
                          <option value="success">Success</option>
                          <option value="pending">Pending</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                      <div className="mt-3 text-end">

                        <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row closed */}

            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">{poolName} Pool</h3>
                  </div>
                  <div className="table-responsive country-table">
                    <div class="gridjs-footer">
                      <div class="gridjs-pagination">
                        <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                        <div className="gridjs-pages text-end">
                          {/* Previous Button */}
                          <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                          {/* First Page */}
                          <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                          {/* Ellipsis if needed */}
                          {pagination.current_page > 3 && <span>...</span>}

                          {/* Middle Pages (2 dynamic pages around current) */}
                          {Array.from({ length: 5 }, (_, i) => {
                            const page = pagination.current_page - 2 + i;
                            if (page > 1 && page < pagination.last_page) {
                              return (
                                <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                  aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                  {page}
                                </button>
                              );
                            }
                            return null;
                          })}

                          {/* Ellipsis if needed */}
                          {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                          {/* Last Page */}
                          {pagination.last_page > 1 && (
                            <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                              onClick={() => handlePageChange(pagination.last_page)}>
                              {pagination.last_page}
                            </button>
                          )}

                          {/* Next Button */}
                          <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                    {tabelLoading ? (

                      <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                        <thead>
                          <tr>
                            <th className="wd-lg-25p">S.N.</th>
                            <th className="wd-lg-25p">CLIENT</th>
                            <th className="wd-lg-25p">Name</th>
                            <th className="wd-lg-25p">Upline</th>
                            <th className="wd-lg-25p">Left Count</th>
                            <th className="wd-lg-25p">Right Count </th>
                            <th className="wd-lg-25p">Team </th>
                            <th className="wd-lg-25p">Income </th>
                            <th className="wd-lg-25p">Cliam History </th>
                            <th className="wd-lg-25p">Join date</th>
                            <th className="wd-lg-25p">STATUS</th>
                            <th className="wd-lg-25p">ACTION</th>
                          </tr>
                        </thead>

                        <tbody>
                          {ClinetData.length > 0 ? (
                            ClinetData.map((dataClient, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td><img class="avatar avatar-md rounded-circle my-auto me-3" src={dataClient.user.profile_image || 'N/A'} alt="Image description" /></td>

                                <td> <h5>{dataClient.user.name || 'N/A'}</h5>
                                  <span>{dataClient.user.my_code || 'N/A'}</span>
                                </td>

                                <td> <h5>{dataClient.upline?.name || 'N/A'}</h5>
                                  <span>{dataClient.upline?.my_code || 'N/A'}</span>
                                </td>


                                <td> {dataClient.left_count || '0'} </td>
                                <td> {dataClient.right_count || '0'} </td>
                                <td> {dataClient.team_count || '0'} </td>
                                <td> ${dataClient.income || '0'} </td>
                                <td>
                                  {dataClient && dataClient.claim
                                    ? dataClient.claim === 'success' ? (
                                      <span className="badge bg-success">Claimed</span>
                                    ) : (
                                      <span className="badge bg-danger">{dataClient.claim} </span>
                                    ) : 'N/A'}
                                </td>
                                <td> {dataClient.date_time} </td>

                                <td>
                                  {dataClient && dataClient.status
                                    ? dataClient.status === 'open' ? (
                                      <span className="badge bg-success">Active</span>
                                    ) : (
                                      <span className="badge bg-danger">{dataClient.status} </span>
                                    ) : 'N/A'}
                                </td>
                                <td>
                                  <a href={`/clientsDetails?userId=` + dataClient.user_id} className="btn btn-sm btn-primary" >
                                    <i className="fa fa-eye"></i>
                                  </a>

                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}


                  </div>
                  <div class="gridjs-footer">
                    <div class="gridjs-pagination">
                      <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                      <div className="gridjs-pages text-end">
                        {/* Previous Button */}
                        <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                        {/* First Page */}
                        <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                        {/* Ellipsis if needed */}
                        {pagination.current_page > 3 && <span>...</span>}

                        {/* Middle Pages (2 dynamic pages around current) */}
                        {Array.from({ length: 5 }, (_, i) => {
                          const page = pagination.current_page - 2 + i;
                          if (page > 1 && page < pagination.last_page) {
                            return (
                              <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                {page}
                              </button>
                            );
                          }
                          return null;
                        })}

                        {/* Ellipsis if needed */}
                        {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                        {/* Last Page */}
                        {pagination.last_page > 1 && (
                          <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                            onClick={() => handlePageChange(pagination.last_page)}>
                            {pagination.last_page}
                          </button>
                        )}

                        {/* Next Button */}
                        <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>

        <div className="modal fade" id="exampleModal" tabindex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLabel1">Package data</h6>
                <button type="button" className="btn-close" data-bs-dismiss="modal"
                  aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary"> Name</b></span>
                  </label>
                  <span className="ms-auto">{stakeData.user?.name || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">User Code</b></span>
                  </label>
                  <span className="ms-auto">{stakeData.user?.my_code || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Package Amount</b></span>
                  </label>
                  <span className="ms-auto"> ${stakeData?.stake_amount || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Monthaly Return</b></span>
                  </label>
                  <span className="ms-auto">{stakeData?.daily_reward_percentage || 'N/A'}%</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Daily Credit</b></span>
                  </label>
                  <span className="ms-auto">${stakeData.daily_credit_reward || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Total Credit </b></span>
                  </label>
                  <span className="ms-auto">${stakeData?.total_credit || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Capping x</b></span>
                  </label>
                  <span className="ms-auto">{stakeData?.stake_capping_x || 'N/A'}X</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Capping Amount</b></span>
                  </label>
                  <span className="ms-auto">${stakeData?.stake_capping_value || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Direct Income</b></span>
                  </label>
                  <span className="ms-auto">${stakeData?.direct_income || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">level Income</b></span>
                  </label>
                  <span className="ms-auto">${stakeData?.level_income || '0'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Total Income</b></span>
                  </label>
                  <span className="ms-auto">${stakeData?.total_income || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Status</b></span>
                  </label>
                  <span className="ms-auto">{stakeData?.stake_status || 'N/A'}</span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Date Time</b></span>
                  </label>
                  <span className="ms-auto">
                    {stakeData.date_time || 'N/A'}
                  </span>
                </div>

                <div className="d-flex p-3 border-top">
                  <label className="">
                    <span> <b className="text-primary">Last Update</b></span>
                  </label>
                  <span className="ms-auto">
                    {stakeData.last_update || 'N/A'}
                  </span>
                </div>


              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-danger"
                  data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>



        <ToastContainer />
      </Header>


      <Footer />

    </>
  )
}

export default Pooldata